import { render, staticRenderFns } from "./PrivacyTerms.vue?vue&type=template&id=722d9f51&scoped=true&"
import script from "./PrivacyTerms.vue?vue&type=script&lang=js&"
export * from "./PrivacyTerms.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyTerms.vue?vue&type=style&index=0&id=722d9f51&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722d9f51",
  null
  
)

export default component.exports